/* eslint-disable @typescript-eslint/naming-convention */
export interface IUtagData {
  ELC_ENV: string;
  CUSTOMER_ID: number;
  ELC_USER_ID: number;
  USER_ID: number;
  brand: string;
  brand_id: string;
  brand_locale: string;
  brand_locale_evar2: string;
  brand_locale_space: string;
  country_code: string;
  language_code: string;
  locale: string;
  birth_date_onfile: number;
  first_order_date: string;
  first_order_value: number;
  join_date: string;
  join_date_year_month: string;
  last_order_date: string;
  last_order_value: number;
  length_of_relationship: number;
  opt_in_state: string;
  orders_avg: number;
  registration_date: string;
  total_count_of_orders: number;
  total_sum_of_revenue: number;
  cart_product_category: string[];
  sms_optin: number;
  pc_email_optin: number;
  cart_product_sku: string[];
  cart_product_is_replenishment_item: string[];
  cart_product_replenishment_frequency: number[];
  cart_product_shade: Array<string | null>;
  cart_product_discount_amount: Array<number | null>;
  customer_state: string;
  cart_product_product_code: string[];
  currency_code: string;
  cart_total_items: number;
  cart_total_value: number;
  cart_product_name: string[];
  cart_product_price: string[]; // ["260", "275", "240"]
  cart_product_quantity: number[];
  cart_product_size: string[];
  cart_product_url: string[];
  cart_product_id: string[];
  recognized_user: number;
  registered_user: number;
  first_order_value_bucket: number;
  total_count_of_orders_bucket: number;
  total_sum_of_revenue_bucket: number;
  crm_total_count_of_orders_bucket: number;
  crm_total_sum_of_revenue_bucket: number;
  signed_in: number;
  page_url: string;
  location: string;
}

export const UTAG_DATA_FIELDS = [
  'ELC_ENV',
  'CUSTOMER_ID',
  'ELC_USER_ID',
  'USER_ID',
  'brand',
  'brand_id',
  'brand_locale',
  'brand_locale_evar2',
  'brand_locale_space',
  'country_code',
  'language_code',
  'locale',
  'birth_date_onfile',
  'first_order_date',
  'first_order_value',
  'join_date',
  'join_date_year_month',
  'last_order_date',
  'last_order_value',
  'length_of_relationship',
  'opt_in_state',
  'orders_avg',
  'registration_date',
  'total_count_of_orders',
  'total_sum_of_revenue',
  'cart_product_category',
  'sms_optin',
  'pc_email_optin',
  'cart_product_sku',
  'cart_product_is_replenishment_item',
  'cart_product_replenishment_frequency',
  'cart_product_shade',
  'cart_product_discount_amount',
  'customer_state',
  'cart_product_product_code',
  'currency_code',
  'cart_total_items',
  'cart_total_value',
  'cart_product_name',
  'cart_product_price',
  'cart_product_quantity',
  'cart_product_size',
  'cart_product_url',
  'cart_product_id',
  'recognized_user',
  'registered_user',
  'first_order_value_bucket',
  'total_count_of_orders_bucket',
  'total_sum_of_revenue_bucket',
  'crm_total_count_of_orders_bucket',
  'crm_total_sum_of_revenue_bucket',
  'signed_in',
];
const GENERAL_VIEW_FIELDS = [
  'brand',
  'brand_id',
  'brand_locale',
  'brand_locale_evar2',
  'brand_locale_space',
  'country_code',
  'language_code',
  'locale',
  'ELC_ENV',
  'currency_code',
  'page_type',
  'page_site_area',
  'page_url',
  'virtual_page_path',
  'location',
  'active_checkout_panel',
  'CUSTOMER_ID',
  'ELC_USER_ID',
  'USER_ID',
  'customer_state',
  'birth_date_onfile',
  'first_order_date',
  'first_order_value',
  'first_order_value_bucket',
  'join_date',
  'join_date_year_month',
  'last_order_date',
  'last_order_value',
  'length_of_relationship',
  'opt_in_state',
  'orders_avg',
  'sms_optin',
  'pc_email_optin',
  'recognized_user',
  'registered_user',
  'registration_date',
  'signed_in',
  'checkout_type',
];

export const PAGE_VIEW_FIELDS = [...GENERAL_VIEW_FIELDS];

export const EVENT_FIELDS = [
  ...GENERAL_VIEW_FIELDS,
  'event_name',
  'event_category',
  'event_action',
  'event_label',
  'checkout_option',
  'checkout_type',
  'enh_action',
  'event_noninteraction',
  'total_count_of_orders',
  'total_sum_of_revenue',
  'total_count_of_orders_bucket',
  'total_sum_of_revenue_bucket',
  'crm_total_count_of_orders_bucket',
  'crm_total_sum_of_revenue_bucket',
  'cart_product_category',
  'cart_product_discount_amount',
  'cart_product_id',
  'cart_product_name',
  'cart_product_price',
  'cart_product_quantity',
  'cart_product_shade',
  'cart_product_size',
  'cart_product_sku',
  'cart_product_url',
  'cart_product_is_preorder',
  'cart_product_is_replenishment_item',
  'cart_product_replenishment_frequency',
  'cart_total_items',
  'cart_total_value',
  'cart_items',
  'order_promo_code',
  'cart_product_product_code',
];

export const LINK_FIELDS = [
  'event_name',
  'event_category',
  'event_action',
  'event_label',
  'checkout_type',
  'location',
  'page_url',
];